module.exports = __webpack_public_path__ + "static/media/piloto2.dac9e30a.png";